import { useTranslation } from 'react-i18next';
import React, { useEffect, useState, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Grid, Card, Button, Table, TableRow, TableHead, TableBody, Box, TableCell, TableContainer, TextField, IconButton, Hidden } from '@mui/material'
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import { useMessage } from "../../context/message-context";
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import TimerIcon from '@mui/icons-material/Timer';
import { setColor } from "../../functions/default";
import EditIcon from '@mui/icons-material/Edit';
import { useTheme } from '@emotion/react';
function ProjektstundenGenehmigen(props) {
  const { t } = useTranslation();
  const { client, accessToken, admin, pReload } = props;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { showErrorMessage } = useMessage();
  const { antragid } = useParams();
  const [antrag, setAntrag] = useState([])
  const [, setZr_offen] = useState("")
  const [, setKz] = useState([])
  const [datum, setDatum] = useState([])
  const [anzeige1, setAnzeige1] = useState("")
  const [anzeige2, setAnzeige2] = useState("")
  const [maxtage, setMaxtage] = useState(-1)
  const [open, setOpen] = useState(-1)
  const [grund, setGrund] = useState("")
  const [openAntrag, setOpenAntrag] = useState(-1)
  const theme = useTheme();
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      "mandant": client, // this.props.client,
      "program": (admin === "J") ? "PPROJ3" : "PPROJN",
      "statement": "GENEHMIGEN",
      "antragid": antragid
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postLaden);
    // eslint-disable-next-line
  }, [])
  const postLaden = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setAntrag(response.data.antrag)
      setZr_offen(response.data.zr_offen)
      setKz(response.data.kz)
      setDatum(response.data.datum)
      setAnzeige1(response.data.anzeige1)
      setAnzeige2(response.data.anzeige2)
      setMaxtage(Number(response.data.maxtage))
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function changeStatus(value, index) {
    if (value === "3") {
      setOpen(index)
      return
    }
    var tmpliste = [...antrag];
    tmpliste[index].status = value;
    tmpliste[index].grund = "";
    setAntrag(tmpliste);
  }
  function changeGrund() {
    if (grund === "") {
      showErrorMessage(t("Grund muss angegeben werden"))
      return
    }
    var tmpliste = [...antrag];
    tmpliste[open].status = "3";
    tmpliste[open].grund = grund;
    setGrund("");
    setOpen(-1);
    setAntrag(tmpliste);
  }
  function Speichern() {
    setIsLoading(true);
    const payload = {
      "mandant": client, // this.props.client,
      "program": (admin === "J") ? "PPROJ3" : "PPROJN",
      "statement": "GENEHM_SPEICHERN",
      "antrag": antrag,
      "anzahl": antrag.length.toString()
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, postSpeichern, errorCb);
  }
  const postSpeichern = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      pReload();
      if (admin === "J") { navigate('/PPROJ3/PPROJN/') } else { navigate('/PPROJN/') }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function errorCb(){
    setIsLoading(false);
    showErrorMessage(t("Es konnte keine Verbindung hergestellt werden"));
  }
  function Abbrechen() {
    if (admin === "J") { navigate('/PPROJ3/PPROJN/') } else { navigate('/PPROJN/') }
  }
  if (isLoading) {
    return <LoadingComponent path={props.location} />
  }
  function onClick(index) {
    setOpenAntrag(index)
  }
  function AnzeigeHeader() {
    return (
      <Fragment>
        {anzeige1}<br />{anzeige2}
      </Fragment>
    )
  }
  function Grundeingabe() {
    return (
      <ResponsiveDialog
        title={t("Grund der Ablehnung")}
        open={open > -1}
        setOpen={(o) => setOpen(-1)}
        actionButton={
          <Grid container justifyContent="center" spacing={1}>
            <Grid item xs={12} sm={6}>
              <Button fullWidth variant="outlined" color="primary" onClick={() => setOpen(-1)}>{t("Abbrechen")}</Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button fullWidth variant="outlined" color="primary" onClick={() => changeGrund()}>{t("Speichern")}</Button>
            </Grid>
          </Grid>
        }
      >
        <Box p={2}>
          <TextField
            variant="outlined"
            fullWidth
            label={t("Grund")}
            value={grund}
            onChange={(e) => setGrund(e.target.value)}
          />
        </Box>
      </ResponsiveDialog>
    )
  }
  function AnzeigeMobil() {
    return (
      <ResponsiveDialog
        title={AnzeigeHeader()}
        open={openAntrag > -1}
        setOpen={(o) => setOpenAntrag(-1)}
        actionButton={
          <Button color="primary" onClick={() => setOpenAntrag(-1)}>{t("Zurück")}</Button>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                disabled
                value={(openAntrag > -1 && antrag[openAntrag]) ? antrag[openAntrag].name : ""}
                label={t("Name")}
              />
            </Grid>
            {openAntrag > -1 && antrag[openAntrag] && antrag[openAntrag].tage && antrag[openAntrag].tage.length > 0 && antrag[openAntrag].tage.slice(0, maxtage).map((item2, index2) => {
              return (
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    disabled
                    value={item2.wert}
                    label={datum[index2].anzeige}
                  />
                </Grid>
              )
            })}
            {openAntrag > -1 && antrag[openAntrag] && antrag[openAntrag].user !== "0000000" &&
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  fullWidth
                  color={(openAntrag > -1 && antrag[openAntrag] && antrag[openAntrag].status === "1") ? "primary" : "inherit"}
                  onClick={() => changeStatus("1", openAntrag)}
                >
                  {
                    (antrag[openAntrag].status === "1") ?
                      <DoneIcon style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }}></DoneIcon>
                      :
                      <DoneIcon style={{ color: setColor("000", "150", "000", "1"), }}></DoneIcon>
                  }
                </Button>
              </Grid>
            }
            {openAntrag > -1 && antrag[openAntrag] && antrag[openAntrag].user !== "0000000" &&
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  fullWidth
                  color={(openAntrag > -1 && antrag[openAntrag] && antrag[openAntrag].status === "2") ? "primary" : "inherit"}
                  onClick={() => changeStatus("2", openAntrag)}
                >
                  {
                    (antrag[openAntrag].status === "2") ?
                      <TimerIcon style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }}></TimerIcon>
                      :
                      <TimerIcon style={{ color: setColor("000", "000", "000", "1"), }}></TimerIcon>
                  }
                  
                </Button>
              </Grid>
            }
            {openAntrag > -1 && antrag[openAntrag] && antrag[openAntrag].user !== "0000000" &&
              <Grid item xs={4}>
                <Button
                  variant="contained"
                  fullWidth
                  color={(openAntrag > -1 && antrag[openAntrag] && antrag[openAntrag].status === "3") ? "primary" : "inherit"}
                  onClick={() => changeStatus("3", openAntrag)}
                >
                  {
                    (antrag[openAntrag].status === "3") ?
                      <CloseIcon style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }}></CloseIcon>
                      :
                      <CloseIcon style={{ color: setColor("150", "000", "000", "1"), }}></CloseIcon>
                  }
                  
                </Button>
              </Grid>
            }
          </Grid>
        </Box>
      </ResponsiveDialog>
    )
  }
  function Tabelle() {
    return (
      <TableContainer>
        <Table>
          {TabelleHead()}
          {TabelleBody()}
        </Table>
      </TableContainer>
    )
  }
  function TabelleHead() {
    return (
      <TableHead>
        <TableRow>
          <TableCell>
            {t("Name")}
          </TableCell>
          <Hidden lgDown>
            {(datum && datum.length > 0) && datum.map((item, index) => {
              return (
                <TableCell>
                  {item.anzeige}
                </TableCell>
              )
            })}
            <TableCell>
              {t("Annehmen")}
            </TableCell>
            <TableCell>
              {t("Abwarten")}
            </TableCell>
            <TableCell>
              {t("Ablehnen")}
            </TableCell>
          </Hidden>
          <Hidden lgUp>
            <TableCell></TableCell>
          </Hidden>
        </TableRow>
      </TableHead>
    )
  }
  function TabelleBody() {
    return (
      <TableBody>
        {antrag && antrag.length > 0 && antrag.map((item, index) => {
          return (
            <TableRow>
              <TableCell>
                {item.name}
              </TableCell>
              <Hidden lgDown>
                {item.tage && item.tage.length > 0 && item.tage.slice(0, maxtage).map((item2, index2) => {
                  return (
                    <TableCell>
                      {item2.wert}
                    </TableCell>
                  )
                })}
                <TableCell>
                  {item.user !== "0000000" &&
                    <Button
                      variant={(item.status === "1") ? "contained" : "contained"}
                      fullWidth
                      color={(item.status === "1") ? "primary" : "inherit"}
                      onClick={() => changeStatus("1", index)}
                    >
                      {
                        (item.status === "1") ?
                          <DoneIcon style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }}></DoneIcon>
                          :
                          <DoneIcon style={{ color: setColor("000", "150", "000", "1"), }}></DoneIcon>
                      }
                    </Button>
                  }
                </TableCell>
                <TableCell>
                  {item.user !== "0000000" &&
                    <Button
                      variant={(item.status === "2") ? "contained" : "contained"}
                      fullWidth
                      color={(item.status === "2") ? "primary" : "inherit"}
                      onClick={() => changeStatus("2", index)}
                    >
                      {
                        (item.status === "2") ?
                          <TimerIcon style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }}></TimerIcon>
                          :
                          <TimerIcon style={{ color: setColor("050", "050", "050", "1"), }}></TimerIcon>
                      }
                    </Button>
                  }
                </TableCell>
                <TableCell>
                  {item.user !== "0000000" &&
                    <Button
                      variant={(item.status === "3") ? "contained" : "contained"}
                      fullWidth
                      color={(item.status === "3") ? "primary" : "inherit"}
                      onClick={() => changeStatus("3", index)}
                    >
                      {
                        (item.status === "3") ?
                          <CloseIcon style={{ color: theme.palette.getContrastText(theme.palette.primary.main) }}></CloseIcon>
                          :
                          <CloseIcon style={{ color: setColor("150", "000", "000", "1"), }}></CloseIcon>
                      }
                    </Button>
                  }
                </TableCell>
              </Hidden>
              <Hidden lgUp>
                <TableCell>
                  <IconButton color="primary" onClick={() => onClick(index)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </Hidden>
            </TableRow>
          )
        })}
      </TableBody>
    )
  }
  return (
    <Grid container justifyContent="center" spacing={2}>
      {AnzeigeMobil()}
      {Grundeingabe()}
      <Grid item xs={12} md={11}>
        <Card>
          <Box p={2}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12}>
                <h4>{anzeige1}<br />{anzeige2}</h4>
              </Grid>
              <Grid item xs={12}>
                {Tabelle()}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => Speichern()}
                  color="primary"
                >
                  {t("Speichern")}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={() => Abbrechen()}
                  color="primary"
                >
                  {t("Verwerfen")}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
}
export default ProjektstundenGenehmigen;
